import React from 'react';
import {
  Landmark, Building2, HeartHandshake, Banknote, Ship, Cpu, Factory, FlaskConical,
} from 'lucide-react';
import { industries } from '../data/mock';

const iconMap = { Landmark, Building2, HeartHandshake, Banknote, Ship, Cpu, Factory, FlaskConical };

export default function Industries() {
  return (
    <section id="industries" className="relative py-20 sm:py-24 lg:py-28 bg-[#faf6ef] overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{ backgroundImage: 'radial-gradient(circle at 10% 10%, #0a1b35 0%, transparent 40%)' }} />

      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12 items-end mb-12 sm:mb-14">
          <div className="lg:col-span-7">
            <p className="text-[#b8842a] tracking-[0.28em] text-[11px] font-semibold uppercase mb-5">
              Industries we serve
            </p>
            <h2 className="font-serif text-[#0a1b35] font-medium text-[32px] sm:text-[40px] lg:text-[52px] leading-[1.08] tracking-tight">
              Sector fluency across the
              <br className="hidden sm:block" />
              <span className="italic text-[#b8842a]"> economy that matters most.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[#0a1b35]/75 text-[15.5px] lg:text-[16.5px] leading-relaxed">
              We have advised and supported organizations spanning the public sector,
              private enterprise, finance, technology, logistics and development
              — absorbing the nuance of each industry and tailoring our engagements accordingly.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#0a1b35]/10 rounded-3xl overflow-hidden border border-[#0a1b35]/10">
          {industries.map((ind) => {
            const Icon = iconMap[ind.icon] || Building2;
            return (
              <div
                key={ind.name}
                className="group bg-[#faf6ef] hover:bg-white p-7 sm:p-8 transition-all duration-500 cursor-pointer relative overflow-hidden"
              >
                <div className="absolute -bottom-12 -right-12 w-32 h-32 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: 'radial-gradient(circle, rgba(184,132,42,0.2) 0%, transparent 70%)' }} />

                <div className="relative">
                  <div className="w-12 h-12 rounded-xl bg-[#0a1b35] flex items-center justify-center mb-5 group-hover:bg-[#b8842a] transition-colors duration-300">
                    <Icon className="w-5 h-5 text-[#e8b863]" strokeWidth={1.5} />
                  </div>
                  <h3 className="text-[#0a1b35] font-semibold text-[16px] lg:text-[17px] leading-snug mb-2">
                    {ind.name}
                  </h3>
                  <p className="text-[#1F2F46] text-[13.5px] leading-relaxed">{ind.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
